import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { ButtonColor } from '../button/button.component';

@Component({
  selector: 'vfs-button-icon',
  templateUrl: './button-icon.component.html',
  styleUrls: ['./button-icon.component.scss']
})
export class ButtonIconComponent extends MatButton {
  @Input() disabled: boolean;
  @Input() type: string;
  @Input() color: ButtonColor = ButtonColor.PRIMARY;
  @Input() label: string;
  @Input() medium: boolean;
  @Input() small: boolean;
  @Input() icon: string;
  @Input() light: boolean;
  @Input() toggle: boolean;
  @Input() showBadge = false;
  @Output() buttonClick = new EventEmitter();
  actived = false;

  onButtonClick(evt: Event) {
    if (!this.disabled) {
      this.buttonClick.emit(evt);
    }
  }
}
